import { notificationManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const notificationManagementRouteMetadata: IRouteMetadataObj<
  typeof notificationManagementRoutesObj
> = {
  list: {
    title: "notification.index.title",
    description: "notification.index.description",
    lazy: () => import("@/pages/notification/table/page"),
    mode: "index",
    type: "main",
    icon: "Notification3Line",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN, IRoleEnum.Teacher, IRoleEnum.ASSISTANT],
  },
  create: {
    title: "notification.create.title",
    description: "notification.create.description",
    lazy: () => import("@/pages/notification/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission: [IRoleEnum.SUPER_ADMIN],
  },
};

export const notificationManagementRoutes = createRoute<
  typeof notificationManagementRoutesObj
>(notificationManagementRoutesObj, notificationManagementRouteMetadata);
